import { FC, useRef, useState, useEffect, useContext, useMemo, forwardRef, useImperativeHandle } from 'react';
import { Button, Image } from 'antd';
// import V2Title from '@/common/components/Feedback/V2Title';
import V2Table from '@/common/components/Data/V2Table';
import { V2Confirm } from '@/common/components/Others/V2Confirm';
import V2Empty from '@/common/components/Data/V2Empty';
import V2Message from '@/common/components/Others/V2Hint/V2Message';
import V2Operate from '@/common/components/Others/V2Operate';
import { isArray, isNotEmptyAny, refactorPermissions } from '@lhb/func';
import { useMethods } from '@lhb/hook';
import styles from '../index.module.less';
import cs from 'classnames';
import ChancePointDetail from '@/common/components/business/ExpandStore/ChancePointDetail';
import ChanceCreateDrawer from '@/common/components/business/ExpandStore/ChanceCreateDrawer';
import SelectTemplateModal from '@/common/components/business/ExpandStore/ChanceCreateDrawer/SelectTemplateModal';
import ChanceForm from '@/common/components/business/ExpandStore/ChanceDetailDrawer/Modules/ChanceForm';
import { MODEL_SYNC_EVENT, TASK_MODEL_SYNC_WARNING, prepareModelSyncApproval } from '@/common/components/business/ExpandStore/modelSync';
import { associateTask, checkApprovalForm, taskChancePointInfo } from '@/common/api/expandStore/expansiontask';
import { revokeYmOaContractApproval } from '@/common/api/expandStore/approveworkbench';
import { getChancePointDetail, getTemplateLists } from '@/common/api/expandStore/chancepoint';
import CreatePointMatching from './CreatePointMatching';
import CreateSpotApproval from '@/common/components/business/ExpandStore/TaskDetailCommon/CreateSpotApproval';
import ApproverDetailDrawer from '@/views/expandstore/pages/approver/components/DetailDrawer';
import ReleaseChance from '@/common/components/business/ExpandStore/ReleaseChance';
import {
  ProtectStatusColor,
  ProtectString,
  ChancePointStatusColor,
  ApprovalStatus,
} from '@/common/components/business/ExpandStore/ts-config';
// import ContractSignModal from '@/views/expandstore/pages/shop/components/ContractSignModal';
// import { bigdataBtn } from '@/common/utils/bigdata';
import ShopEditDrawer from '@/views/expandstore/pages/shopEdit/Drawer';
import { useBigdataFn } from '@/common/utils/bigdata';
import AreaProtectionDrawer from '@/common/components/business/AreaProtection/detail';
import UserInfoContext from '@/layout/context';
import { ShopEditType } from '@/views/expandstore/pages/shopEdit/ts-config';
import { useTenantCheckInfo } from '@/common/hook/useTenantCheckInfo';
import CreateChanceApproval from './CreateChanceApproval';
// import { addressIdentification } from '@/common/components/business/DynamicComponent/customize';
import ApprovalCreateWithYmOADialog from 'src/common/components/business/ExpandStore/ApprovalCreateWithYmOADialog/index';


/**
 * 拓店任务-详情-匹配点位-机会点
 * @Description 加盟+直营A（基诺浦）、加盟+直营B（一鸣）
 * 目前看来卡旺卡和普通拓店任务处理的差异：modelClusterId参数
 */
const PointMatching: FC<{
  /** 拓店任务ID */
  id: number;
  /** 是否 Locxx 拓店任务。 */
  isLocxx?: boolean;
  /** 拓店任务商圈id */
  modelClusterId: number;
  /** 提交前详情弹窗中的拓店任务详情 */
  taskDetail?: any;
  // modelClusterInfo: any;
  /** 匹配点位信息 */
  chancePointInfo: any;
  /** 设置机会点数据 */
  setChancePointInfo:Function;
  /** 是否只能查看（审批详情时只能查看） */
  isView: boolean;
  /** 外部新增按钮是否可见 */
  showAddBtn?: boolean;
  refresh: Function;
  chancepointAlias?: string;
  hideOperate?: boolean;
  /** 展示外部的新增机会点按钮文案，为空则不展示按钮 */
  setAddPointButtonText?: any,
  /** 模型同步进行中时的通知，用于锁住整个详情弹窗 */
  onSyncLoadingChange?: (loading: boolean) => void,
  ref?: any
}> = forwardRef(({
  id,
  isLocxx = false,
  /** 拓店任务商圈id */
  modelClusterId,
  taskDetail,
  // modelClusterInfo,
  chancePointInfo,
  isView,
  showAddBtn = true,
  setChancePointInfo,
  refresh,
  chancepointAlias,
  hideOperate,
  setAddPointButtonText,
  onSyncLoadingChange,
}, ref) => {

  const {
    /** 当前租户的拓店任务模板是否“加盟+直营B（一鸣）”，未确定时为null */
    isStandardAndClusterBTaskTemplate,
    /** 当前租户的检查信息 */
    tenantCheckInfo,
  } = useTenantCheckInfo();

  /** 是否一鸣租户（模型同步为仅一鸣可用的定制功能） */
  const isYiMing = !!tenantCheckInfo?.isYiMing;

  useImperativeHandle(ref, () => ({
    addChancePoint: methods.handleCreatePointMatching,
    // 打开机会点详情
    openChancePointDetail: (chancePointId: number | string) => {
      methods.onClickDetail({ id: chancePointId });
    },
  }));

  const bigdataFn = useBigdataFn(); // 使用埋点 Hook
  const editRef: any = useRef();
  const syncFormRef: any = useRef();
  const syncContainerRef: any = useRef();
  const syncDynamicTabContentRefs: any = useRef([]);
  const syncDynamicTabsRef: any = useRef([]);
  const syncDynamicTabActiveRef: any = useRef('');
  const syncResolveRef = useRef<((success: boolean) => void) | null>(null);
  const syncInProgressRef = useRef(false);
  const syncRefreshRef = useRef(true);
  const approvalPreparingRef = useRef(false);
  const approvalContextRef = useRef<object>({});
  const [preparingApproval, setPreparingApproval] = useState(false);
  const createPointMatchingRef: any = useRef();
  const createChanceApprovalRef: any = useRef();
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [filters, setFilters] = useState<any>(); // 筛选参数
  const [showCreateModal, setShowCreateModal] = useState<boolean>(false); // 是否显示新建弹窗
  const [selectTemplateVisible, setSelectTemplateVisible] = useState<boolean>(false);
  const [templateList, setTemplateList] = useState<any[]>([]);

  const [pointId, setPointId] = useState<number>(); // 机会点id
  const [showPointDetail, setShowPointDetail] = useState<boolean>(false); // 是否显示机会点详情弹窗
  const [areaProtectOpen, setAreaProtectOpen] = useState<boolean>(false);// 发起保护
  const [refreshDetail, setRefreshDetail] = useState<number>(0); // 刷新机会点详情
  const [formDrawerData, setFormDrawerData] = useState<any>({
    open: false,
    templateId: '', // 模板id
    id: '', // 编辑时的id
  }); // 机会点详情上的编辑
  const [drawerData, setDrawerData] = useState<any>({
    open: false,
    templateId: '', // 模板id
    id: '', // 编辑时的id
    expandStoreData: null, // 拓店任务相关信息
  }); // 完善点位评估编辑
  const [syncChanceDetail, setSyncChanceDetail] = useState<any>();
  const [syncLoading, setSyncLoading] = useState<boolean>(false);
  const [syncPointId, setSyncPointId] = useState<number>();

  /**
   * @description 模型同步的 loading 状态
   *
   *   除按钮自身 loading 外，同时通知外层给整个详情弹窗加遮罩，
   *   避免同步过程中还能操作弹窗内的其它入口。
   */
  useEffect(() => {
    approvalContextRef.current = {};
    approvalPreparingRef.current = false;
    syncInProgressRef.current = false;
    setPreparingApproval(false);
    setSyncChanceDetail(undefined);
    setSyncPointId(undefined);
    setSyncLoading(false);
    return () => {
      approvalContextRef.current = {};
      syncResolveRef.current?.(false);
      syncResolveRef.current = null;
      onSyncLoadingChange?.(false);
    };
  }, [id, isView, hideOperate, isYiMing]);

  const [releaseData, setReleaseData] = useState<any>({
    open: false,
    id: '', // 解除绑定时的任务id
  }); // 解除绑定弹窗
  const [approvalModal, setApprovalModal] = useState<any>({
    show: false,
    id: undefined, // 机会点ID
    type: undefined, // 审批类型
    typeValue: undefined, // 审批子类
    standardTaskId: undefined, // 任务id（机会点点位评估时用，比如一鸣）
    evaluationFlowId: undefined, // 机会点模板关联点位评估审批流id
  }); // 提交审批弹窗
  const [contractApprovalData, setContractApprovalData] = useState<any>({
    id: null,
    open: false,
  }); // 合同签约审批详情
  // const [signVisible, setSignVisible] = useState(false); // 合同签约弹窗
  const { tenantInfo } = useContext(UserInfoContext); // 租户信息

  const [approvalCreateWithYmOADialogVisible, setApprovalCreateWithYmOADialogVisible] = useState<boolean>(false); // 是否显示「拓店详情-机会点列表-合同审批（需要一鸣 OA）」弹窗

  /**
   * @description 是否启用机会点与任务自动关联
   *
   *  加盟商拓店模板A:
   *    益禾堂租户的有址选址任务类型，特殊处理为添加机会点后自动关联；其他都为手动关联
   *  直营模板、直营+加盟模板:
   *    这两套任务模板下，最早都是按照是否位于开店区域内来自动关联，24/12/27卡旺卡租户希望使用手动关联方式，所以增加了配置，可控制是否自动关联。
   *
   *   区别，自动关联时展示“添加机会点”，手动关联时展示“关联机会点”
   */
  const isAutoRelate = useMemo(() => {
    return tenantInfo?.taskAutoAssociatePointEnable;
  }, [tenantInfo]);

  /**
   * @description 添加文案，与是否自动关联及别名有关
   */
  const addText = useMemo(() => {
    return (isAutoRelate ? '创建' : '关联') + chancepointAlias;
  }, [isAutoRelate, chancepointAlias]);

  /**
   * @description 是否仅允许关联审批通过的机会点
   *
   *   租户设置了仅可关联审批过的机会点
   */
  const onlyApprovedChance = useMemo(() => {
    return !!tenantInfo?.onlyAllowRelatedApprovalPoint;
  }, [tenantInfo]);

  /**
   * @description 是否可以手动解除绑定机会点
   *
   * 需要满足：
   *  可操作场景（审批详情、或者拓店任务状态非进行中时不可操作）
   *  点位和任务自动关联，设置为OFF
   */
  const canManualRelease = useMemo(() => {
    return !isView && !isAutoRelate;
  }, [isAutoRelate, isView]);

  /** 展示内部列表上方的新增按钮 */
  const showInnerAddButton = !isView && showAddBtn && !!chancePointInfo?.objectList?.length;

  useEffect(() => {
    getTemplateLists().then((result) => {
      setTemplateList(result.map((item) => ({ label: item.templateName, value: item.id })));
    });
  }, []);
  useEffect(() => {
    // 为了和内部显示逻辑统一
    setAddPointButtonText?.(chancePointInfo?.objectList?.length ? addText : '');
  }, [chancePointInfo?.objectList, addText]);


  /**
   * @description 机会点创建带入地址字段、地址会自动带出开店区域信息
   * @return
   */
  // const assignedChanceData = useMemo(() => {
  //   if (!isNotEmptyAny(modelClusterInfo)) return [];

  //   const {
  //     centerLng: lng,
  //     centerLat: lat,
  //     modelClusterName: name,
  //   } = modelClusterInfo;
  //   const params: any[] = [];
  //   if (+lng && +lat && name) {
  //     const basicAddress = {
  //       identification: addressIdentification,
  //       textValue: JSON.stringify({
  //         address: name,
  //         longitude: lng,
  //         latitude: lat,
  //         poiName: name
  //       })
  //     };
  //     params.push(basicAddress);
  //   }
  //   return params;
  // }, [modelClusterInfo]);

  const basicColumns = [
    {
      key: 'shopImgUrls',
      title: '点位图片',
      width: 90,
      render: (value) =>
        <Image
          width={70}
          height={52}
          style={{ borderRadius: 2, }}
          src={isArray(value) && value.length
            ? value?.[0]
            : `${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/task/ic_place_noimg.png` }
        />
    },
    {
      key: 'name',
      title: '点位名称',
      width: 240,
      dragChecked: true,
      noTooltip: true,
      render: (value, record) => {
        return isNotEmptyAny(value) ? (
          <span
            className={cs(styles.tableColumnName, hideOperate ? '' : styles.highlight)}
            onClick={() => methods.onClickDetail(record)}
          >
            {value}
          </span>
        ) : (
          '-'
        );
      },
    }, {
      key: 'address',
      title: '详细地址',
      width: 402,
      importWidth: true,
      dragChecked: true,
      render: (value) => isNotEmptyAny(value) ? value : '-',
    }, {
      key: 'statusName',
      title: '状态',
      width: 'auto',
      dragChecked: true,
      render: (value, record) => isNotEmptyAny(value) ? <span
        style={{
          color: ChancePointStatusColor[record?.status]
        }}
      >{value}</span> : '-',
    },
    // {
    //   key: 'process',
    //   title: '填写进度',
    //   width: 'auto',
    //   render: (value, record) => (
    //     <>
    //       <Progress
    //         percent={record.requiredNum / record.requiredTotalNum * 100}
    //         showInfo={false}
    //         trailColor='#ddd'
    //         style={{
    //           width: '64px',
    //           marginRight: 8
    //         }}/>
    //       {record.requiredNum}/{record.requiredTotalNum}
    //     </>
    //   )
    // },
  ];

  const protectColumn = {
    key: 'protectStatusName',
    title: '保护状态',
    width: 'auto',
    dragChecked: true,
    render: (value, record) => {
      const protectStatusName = record?.protectInfo?.statusName;
      if (isNotEmptyAny(protectStatusName)) {
        return <span style={{
          color: ProtectStatusColor[protectStatusName] || '#666666'
        }}>{protectStatusName}</span>;
      } else {
        // 区域保护可用时，显示未保护，否则显示-
        const canApplyProtect = isArray(record?.processButton) && !!record?.processButton.find((itm: any) => itm.code === 'standardChancePoint:submitProtect');
        return canApplyProtect ? <span style={{
          color: ProtectStatusColor[ProtectString.Off]
        }}>{ProtectString.Off}</span> : '-';
      };
    }
  };

  const operateColumn = {
    key: 'processButton',
    title: '操作',
    width: 'auto',
    dragChecked: true,
    render: (value, record) => {
      const processButtons = methods.formatProcessButtons(value);
      const operateList = refactorPermissions(isArray(processButtons) ? processButtons.map(itm => ({ ...itm, event: itm.code })) : [])
        .map(btn => ({ ...btn, disabled: btn.disabled || preparingApproval }));

      return !hideOperate && operateList.length ? (<V2Operate
        operateList={operateList}
        onClick={(btn: any) => methods[btn.func](btn, record)}
      />) : '-';
    }
  };

  const defaultColumns = tenantInfo && tenantInfo?.protectFlag ? [...basicColumns, protectColumn, operateColumn] : [...basicColumns, operateColumn];

  const methods = useMethods({

    setSyncLoadingState(loading: boolean) {
      setSyncLoading(loading);
      onSyncLoadingChange?.(loading);
    },

    /**
     * @description 处理机会点列表操作按钮
     */
    formatProcessButton(btn) {
      return {
        ...btn,
        disabled: !!btn.disabled || (syncLoading && btn.code === MODEL_SYNC_EVENT),
        useLoadingWidthAsync: btn.code === MODEL_SYNC_EVENT,
      };
    },
    formatProcessButtons(buttons) {
      const processButtons = [...(buttons || [])];
      return processButtons.map(methods.formatProcessButton);
    },
    /**
     * @description 获取机会点详情并在屏幕外复用机会点编辑表单执行模型同步（仅一鸣租户）
     */
    canUpdateModule(record) {
      if (!isYiMing || isView || hideOperate || syncLoading || syncInProgressRef.current || !record?.id) return false;
      const buttons = methods.formatProcessButtons(record.processButton);
      const operates = refactorPermissions(buttons.map(btn => ({ ...btn, event: btn.code })));
      return operates.some(btn => btn.event === 'updateModule' && !btn.hide && !btn.disabled);
    },
    handleUpdateModule(item, record, latestDetail?: any, forApproval = false): Promise<boolean> {
      if (!methods.canUpdateModule(record)) return Promise.resolve(false);
      syncInProgressRef.current = true;
      syncRefreshRef.current = !forApproval;
      const context = approvalContextRef.current;
      methods.setSyncLoadingState(true);
      setSyncPointId(record.id);
      return new Promise<boolean>((resolve) => {
        syncResolveRef.current = resolve;
        // 审批前已请求最新详情，复用该快照，避免重复请求与时序漂移。
        const detailPromise = latestDetail ? Promise.resolve(latestDetail) : getChancePointDetail({ id: record.id });
        detailPromise.then((detail) => {
          if (approvalContextRef.current !== context) return;
          setSyncChanceDetail(detail);
        }, () => {
          if (approvalContextRef.current === context) methods.handleSyncComplete(false);
        });
      });
    },
    /** 模型同步必须以保存结果收尾；失败时不能继续审批。 */
    handleSyncComplete(success: boolean) {
      if (success && syncRefreshRef.current) {
        refresh();
        setFilters({});
        createPointMatchingRef?.current?.onLoad();
      }
      setSyncChanceDetail(undefined);
      setSyncPointId(undefined);
      syncInProgressRef.current = false;
      methods.setSyncLoadingState(false);
      syncResolveRef.current?.(success);
      syncResolveRef.current = null;
    },

    /**
     * @description 提交审批前执行模型同步前置检查。
     *
     * 这里只负责模型同步，调用方继续保留各自原有的审批处理逻辑。
     */
    async prepareModelSyncForApproval(item, record): Promise<boolean> {
      if (!methods.canUpdateModule(record)) return true;

      const context = approvalContextRef.current;
      approvalPreparingRef.current = true;
      setPreparingApproval(true);
      const canContinue = await prepareModelSyncApproval({
        enabled: true,
        id: record.id,
        message: TASK_MODEL_SYNC_WARNING,
        getDetail: getChancePointDetail,
        synchronize: latestDetail => methods.handleUpdateModule(item, record, latestDetail, true),
        isCurrent: () => approvalContextRef.current === context,
      });
      if (approvalContextRef.current !== context) return false;
      approvalPreparingRef.current = false;
      setPreparingApproval(false);
      return canContinue;
    },

    /** 点位评估 */
    async handleEvaluationCreateApproved(item, record) {
      if (isView || !item.isHighlight) return; // 审批详情时不可编辑，或者按钮不高亮的内容不可点击
      if (isStandardAndClusterBTaskTemplate) {
        setDrawerData({
          open: true,
          templateId: '', // 模板id
          id: record.id, // 编辑时的id
          expandStoreData: item, // 拓店任务相关信息
          evaluationFlowId: item.evaluationFlowId, // 机会点点位评估审批流ID
        });
        return;
      }
      const res = await checkApprovalForm({
        type: item.approvalType,
        typeValue: item.approvalTypeValue,
        relationId: record.id
      });
      if (res) {
        // 必填校验通过的时候打开发起审批弹窗
        setApprovalModal({
          show: true,
          type: item.approvalType,
          typeValue: item.approvalTypeValue,
          id: record.id
        });
      } else {
      // 必填校验未通过
        V2Confirm({
          onSure: (modal: any) => {
            setDrawerData({
              open: true,
              templateId: '', // 模板id
              id: record.id, // 编辑时的id
              expandStoreData: item, // 拓店任务相关信息
            });
            modal.destroy();
          },
          okText: '去补充',
          title: '信息提示',
          content: `您的${chancepointAlias || '机会点'}暂未填写完整，请去补充${chancepointAlias}信息`
        });
      }
    },
    /** 保存 Locxx 机会点时沿用已有任务关联接口。 */
    async ensureLocxxTaskAssociation(chancePointId: number) {
      if (!isLocxx || isView || !chancePointId) return [];
      const taskChancePoints = await taskChancePointInfo({ id });
      const isAssociated = isArray(taskChancePoints?.objectList) && taskChancePoints.objectList.some((item: any) => +item.id === +chancePointId);
      if (!isAssociated) {
        await associateTask({ id, chancePointIds: [chancePointId] });
        return await taskChancePointInfo({ id });
      }
      return taskChancePoints;
    },
    async handleLocxxTaskSave(chancePointId: number) {
      await methods.ensureLocxxTaskAssociation(chancePointId);
      methods.handleRefresh();
    },
    /**
     * @description 目前只有直营+加盟B模板（一鸣）会执行到
     * @param item
     * @param record
     * @return
     */
    openApprovalModal(item, record) {
      setApprovalModal({
        show: true,
        type: item.approvalType,
        typeValue: item.approvalTypeValue,
        id: record.id,
        standardTaskId: id, // 任务id
        evaluationFlowId: item.evaluationFlowId, // 机会点点位评估审批流ID
        propertyValues: record.propertyValues
      });
    },
    /** 表单内提交点位评估后续操作 */
    closeApprovalModal() {
      if (drawerData.open) {
        setDrawerData({
          open: false,
          templateId: '', // 模板id
          id: '', // 编辑时的id
          expandStoreData: null // 拓店任务相关信息
        });
      }
    },

    /** 合同签约/合同审批 */
    handleContractCreateApproved(item, record) {
      if (item.isYmOaContract) {
        setApprovalCreateWithYmOADialogVisible(true);
        setPointId(record.id);
        return;
      }
      const { approvalId, approvalStatus } = record?.contractApprovingInfo || {};
      if (approvalId && approvalStatus === ApprovalStatus.Untreated) {
        // 签约审批中
        setContractApprovalData({
          id: approvalId,
          open: true,
        });
      } else {
        // 还未生成审批，则允许发起审批，或直接签约通过
        setPointId(record.id);
        // setSignVisible(true);
        editRef.current.init({
          id: record.id,
          type: ShopEditType.Sign,
          standardTaskId: id,
        });
        bigdataFn('e85b86cd-7d3a-4b8e-948b-c18e341bac56', '拓店任务详情-签约', '点击了拓店任务详情-签约', { op_block: '拓店任务管理', op_event: ``, });
      }
    },
    /** 合同审批撤销 */
    handleContractRevokeApproved(item, record) {
      if (!item.isYmOaContract) return;
      V2Confirm({
        content: '确认撤销该审批？',
        onSure() {
          revokeYmOaContractApproval({ chancePointId: record.id }).then(() => {
            V2Message.success('撤销审批成功');
            refresh();
            setFilters({});
          });
        }
      });
    },
    /** 保护 */
    handleSubmitProtect(item, record) {
      setPointId(record.id);
      setAreaProtectOpen(true);
    },
    /** 解绑 */
    handleRelease(item, record) {
      setReleaseData({
        open: true,
        id: record.id,
      });
    },
    /** 编辑 */
    handleEdit(item, record) {
      setFormDrawerData({
        id: record.id,
        open: true,
        templateId: '',
      });
    },
    /**
     * @description 发起机会点审批（操作列的权限按钮）
     */
    async handleChangePointCreatedApproved(item, record) {
      if (approvalPreparingRef.current) return;
      if (!await methods.prepareModelSyncForApproval(item, record)) return;
      createChanceApprovalRef.current?.create(record.id);
    },

    /**
     * @description 加载表格数据
     */
    loadData: async() => {
      if (!id) return;
      const params: any = { id };
      if (isStandardAndClusterBTaskTemplate) {
        params.modelClusterId = modelClusterId;
      }
      const data = await taskChancePointInfo(params);

      const list = isArray(data.objectList) ? data.objectList.map(itm => {
        const hasReleaseBtn = !!itm.releaseButton && canManualRelease;
        if (!hasReleaseBtn) return itm;
        const releaseBtn = {
          'sort': null,
          'name': '取消关联',
          'approvalTypeValue': null,
          'approvalType': null,
          'approvalFlowId': null,
          'code': 'release',
          'isComplete': false,
          'isHighlight': true
        };
        return {
          ...itm,
          processButton: [...(itm.processButton || []), releaseBtn]
        };
      }) : [];
      setChancePointInfo(data);
      setIsLoading(false);
      return {
        dataSource: list,
        count: data?.totalNum > 0 ? data?.totalNum : 0,
      };
    },

    /**
     * @description 点击名称查看详情
     * @param record 当前选中点击某一行的数据
     */
    onClickDetail: (record) => {
      // if (isView) return;
      if (hideOperate) return;
      setPointId(record.id); // 机会点ID
      setShowPointDetail(true); // 显示弹窗
    },

    /**
     * @description 机会点创建成功，提示去查看（仅限直营+加盟B模板时）
     * @param chanceId
     * @return
     */
    handleChanceCreated(chanceId: number) {
      if (!isStandardAndClusterBTaskTemplate) return;
      V2Confirm({
        onSure: (modal: any) => {
          methods.onClickDetail({ id: chanceId });
          modal.destroy();
        },
        okText: '去查看',
        title: '机会点已创建成功',
        content: `可以点击去查看该${chancepointAlias || '机会点'}详情页`
      });
    },

    /** 打开详情页时的编辑表单的刷新详情页 */
    updateHandle: () => {
      const curVal = refreshDetail + 1;
      setRefreshDetail(curVal);
    },

    /** 关联机会点/创建机会点 */
    handleCreatePointMatching: () => {
      if (isAutoRelate) {
        /* 自动关联
          单一机会点模板：直接打开创建机会点抽屉
          多个机会点模板：展示选择模板弹框
        */
        templateList?.length === 1 ? setFormDrawerData && setFormDrawerData({
          templateId: templateList[0]?.value,
          open: true,
        }) : setSelectTemplateVisible(true);
        return;
      }
      // bigdataBtn('b3561739-7a76-5764-8013-7c0fcf77b2ca', '拓店任务', '关联机会点', `点击了关联机会点`);
      bigdataFn('7f86d97e-6ddc-403c-9980-2dc72c598dab', '拓店任务详情-关联机会点', '点击了拓店任务详情-关联机会点', { op_block: '拓店任务管理', op_event: ``, });
      // 手动关联，展示关联弹框
      setShowCreateModal(true);
    },

    /**
     * @description 刷新
     */
    handleRefresh() {
      refresh(); // 回调外层
      setFilters({}); // 刷新本列表
    }
  });

  return (
    <>
      <div className={styles.pointMatching} >
        {/* <V2Title type='H2' text='匹配机会点情况' divider/> */}
        {!!showInnerAddButton && <span className={styles.addInfo} onClick={methods.handleCreatePointMatching}>+ {addText}</span>}
        <V2Table
          key={!!tenantInfo?.protectFlag} // 当key值不同的时候强制重新渲染table,获取新的表头项
          filters={filters}
          loading={false}
          rowKey='id'
          type='easy'
          pagination={false}
          defaultColumns={defaultColumns}
          hideColumnPlaceholder
          scroll={{ x: '100%' }}
          onFetch={methods.loadData}
          className={cs(chancePointInfo?.objectList?.length ? '' : styles.hide, 'mt-12')}
        />
        {/* loading结束且没数据才会显示空状态 */}
        { chancePointInfo?.objectList?.length || isLoading ? <></> : <V2Empty
          className='mt-100'
          customTip={!isView ? <Button
            onClick={methods.handleCreatePointMatching}
            type='primary'>{addText}</Button> : '暂无点位'}
        />
        }
      </div>

      {/* 屏幕外复用机会点编辑表单，模型同步完成后立即卸载（仅一鸣租户）。 */}
      {syncChanceDetail && <div
        ref={syncContainerRef}
        style={{ position: 'fixed', left: '-10000px', top: 0, width: 1200, height: 800, overflow: 'hidden' }}
      >
        <ChanceForm
          ref={syncFormRef}
          id={syncPointId}
          chanceDetail={syncChanceDetail}
          isApproval={false}
          approvalId={undefined}
          onSearch={undefined}
          update={undefined}
          setHintStr={undefined}
          setHasEditableProperty={undefined}
          container={syncContainerRef}
          dynamicTabActiveRef={syncDynamicTabActiveRef}
          dynamicTabContentRefs={syncDynamicTabContentRefs}
          dynamicTabsRef={syncDynamicTabsRef}
          dynamicTabsActive={undefined}
          setDynamicTabsActive={undefined}
          disabledArea={true}
          setLoading={methods.setSyncLoadingState}
          autoUpdateModule
          showModelSyncSuccess={syncRefreshRef.current}
          onUpdateModuleComplete={methods.handleSyncComplete}
        />
      </div>}

      {/* 匹配机会点 */}
      <CreatePointMatching
        ref={createPointMatchingRef}
        id={id}
        modelClusterId={modelClusterId}
        chancepointAlias={chancepointAlias}
        onlyApprovedChance={onlyApprovedChance}
        refresh={() => {
          refresh();
          setFilters({});
        }}
        open={showCreateModal}
        setOpen={setShowCreateModal}
        setFormDrawerData={setFormDrawerData}
      />

      {/* 模版选择框  */}
      <SelectTemplateModal
        setVisible={setSelectTemplateVisible}
        visible={selectTemplateVisible}
        chancepointAlias={chancepointAlias}
        setFormDrawerData={setFormDrawerData}
      />

      {/* 机会点详情 */}
      <ChancePointDetail
        taskId={id}
        projectSearchDefaults={{
          city: taskDetail?.modelClusterInfo ? [taskDetail.targetProvinceId, taskDetail.targetCityId] : undefined,
          projectName: taskDetail?.modelClusterInfo?.modelClusterName,
          longitude: taskDetail?.modelClusterInfo?.centerLng,
          latitude: taskDetail?.modelClusterInfo?.centerLat,
        }}
        pointId={pointId}
        detailVisible={showPointDetail}
        setDetailVisible={setShowPointDetail}
        setFormDrawerData={setFormDrawerData}
        chancepointAlias={chancepointAlias}
        // assignedData={assignedChanceData}
        refreshDetail={refreshDetail}
        formDrawerData={formDrawerData}
        // expansionTaskId={id}
        expansionTaskClusterId={modelClusterId}
        isLocxxTask={isLocxx}
        handleLocxxSave={methods.handleLocxxTaskSave}
        handleCreateSuccessed={methods.handleChanceCreated}
        updateHandle={methods.updateHandle}
        onSearch={() => {
          refresh();
          setFilters({});
          createPointMatchingRef?.current?.onLoad();
        }}
      />

      <CreateChanceApproval ref={createChanceApprovalRef} handleApprovalCreated={methods.handleRefresh}/>

      {/* 完善点位评估时打开机会点编辑弹窗 */}
      <ChanceCreateDrawer
        drawerData={drawerData}
        isExpandStoreTaskIn
        isLocxxTask={isLocxx}
        taskId={id}
        handleLocxxSave={methods.handleLocxxTaskSave}
        handleExpandStoreApproved={isStandardAndClusterBTaskTemplate ? methods.openApprovalModal : methods.handleEvaluationCreateApproved}
        onSearch={methods.handleRefresh}
        handleEditSuccessed={methods.handleRefresh}
        closeHandle={() =>
          setDrawerData({
            open: false,
            templateId: '', // 模板id
            id: '', // 编辑时的id
            expandStoreData: null, // 拓店任务相关信息
            evaluationFlowId: null
          })
        }
      />

      {/* 提交审批弹窗 */}
      <CreateSpotApproval
        refresh={() => {
          refresh();
          setFilters({});
          methods.closeApprovalModal();
        }} // 刷新
        approvalModal={approvalModal}
        setApprovalModal={setApprovalModal}
      />
      {/* 合同签约 */}
      <ShopEditDrawer ref={editRef} reload={() => {
        refresh();
        setFilters({});
      }}/>
      {/* <ContractSignModal visible={signVisible} setVisible={setSignVisible} id={pointId} onRefresh={() => {
        refresh();
        setFilters({});
      }}/> */}

      {/* 区域保护弹窗 */}
      <AreaProtectionDrawer
        id={pointId}
        open={areaProtectOpen}
        setOpen={setAreaProtectOpen}
        updateHandle={() => {
          refresh();
          setFilters({});
        }}
      />
      {/* 解除绑定弹窗 */}
      <ReleaseChance
        chancepointAlias={chancepointAlias}
        modalData={releaseData}
        setModalData={setReleaseData}
        refresh={() => {
          refresh();
          setFilters({});
        }}
      />
      {/* 审批详情抽屉 */}
      <ApproverDetailDrawer
        id={contractApprovalData?.id}
        open={contractApprovalData?.open} // 是否可见
        setOpen={(op) => {
          setContractApprovalData((state) => ({
            ...state,
            open: op,
          }));
        }}
        onRefresh={() => {
          refresh();
          setFilters({});
        }}
      />

      {/* 拓店详情-机会点列表-合同审批（需要一鸣 OA） */}
      <ApprovalCreateWithYmOADialog
        visible={approvalCreateWithYmOADialogVisible}
        setVisible={setApprovalCreateWithYmOADialogVisible}
        taskId={id}
        id={pointId as number}
        taskDetail={taskDetail}
        onComplete={() => {
          refresh();
          setFilters({});
        }}
      />

    </>

  );
});

export default PointMatching;
